/** sessionStorage：列表页跳转订单详情全屏页时携带的 OrderCardDTO */
export const HM_CARE_ORDER_DETAIL_KEY = 'hmCareOrderDetailFocus'

/** sessionStorage：Technicians 列表跳转 HM Care Orders 时预填 Technician / Inspector 筛选 */
export const HM_CARE_ORDERS_LIST_PREFILL_KEY = 'hmCareOrdersListPrefill'

export interface HmCareOrdersListPrefill {
  technicianId?: string
  technicianName?: string
  inspectorId?: string
  inspectorName?: string
}

export function writeHmCareOrdersListPrefill(payload: HmCareOrdersListPrefill): void {
  sessionStorage.setItem(HM_CARE_ORDERS_LIST_PREFILL_KEY, JSON.stringify(payload))
}

export function readHmCareOrdersListPrefill(): HmCareOrdersListPrefill | null {
  try {
    const raw = sessionStorage.getItem(HM_CARE_ORDERS_LIST_PREFILL_KEY)
    if (!raw) return null
    sessionStorage.removeItem(HM_CARE_ORDERS_LIST_PREFILL_KEY)
    const parsed = JSON.parse(raw) as unknown
    if (!parsed || typeof parsed !== 'object') return null
    const o = parsed as HmCareOrdersListPrefill
    const pick = (v: unknown): string | undefined =>
      typeof v === 'string' && v.trim() ? v.trim() : undefined
    const technicianId = pick(o.technicianId)
    const technicianName = pick(o.technicianName)
    const inspectorId = pick(o.inspectorId)
    const inspectorName = pick(o.inspectorName)
    if (!technicianId && !inspectorId) return null
    return { technicianId, technicianName, inspectorId, inspectorName }
  } catch {
    return null
  }
}
